export const OPEN_INTEGRATION_EVENT_MODAL = 'OPEN_INTEGRATION_EVENT_MODAL';